"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var layout_1 = require("../../_shared/components/layout");
var model_1 = require("../../../model");
var _ = require("lodash");
var index_1 = require("../../_shared/components/inputs/index");
var FormComponent_1 = require("../../_shared/components/inputs/FormComponent");
var Identity_1 = require("../../../model/Identity");
var UsersTable_1 = require("./UsersTable");
var moment = require("moment");
var UserDataForm = /** @class */ (function (_super) {
    __extends(UserDataForm, _super);
    function UserDataForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, _this.transformPropsToState(_this.props.user));
        return _this;
    }
    UserDataForm.prototype.componentWillReceiveProps = function (newProps) {
        this.setState(__assign({}, this.transformPropsToState(newProps.user)));
    };
    UserDataForm.prototype.transformPropsToState = function (user) {
        var initialState = __assign(__assign({}, model_1.emptyUser), { roles: null, normHours: 0, normDays: 0, lunchTime: 0, travelTime: 0, isActive: 0, selectedCompanyIds: [], canPreviewGpsProposal: false, emailError: '' });
        if (!user) {
            return initialState;
        }
        var username = user.username, email = user.email, lastName = user.lastName, firstName = user.firstName, lastNamePrefix = user.lastNamePrefix, role = user.role, isActive = user.isActive, _a = user.settings, normDays = _a.normDays, normHours = _a.normHours, travelTime = _a.travelTime, lunchTime = _a.lunchTime, companies = _a.companies, canPreviewGpsProposal = _a.canPreviewGpsProposal;
        return {
            username: username,
            email: email,
            lastName: lastName,
            firstName: firstName,
            lastNamePrefix: lastNamePrefix,
            password: '',
            role: role,
            normDays: normDays,
            normHours: normHours,
            lunchTime: lunchTime || 0,
            travelTime: travelTime,
            isActive: isActive ? 1 : 0,
            roles: model_1.ROLES[user.type],
            selectedCompanyIds: companies || [],
            canPreviewGpsProposal: !!canPreviewGpsProposal,
            emailError: '',
        };
    };
    UserDataForm.prototype.transformStateToUSer = function () {
        var _a = this.state, username = _a.username, email = _a.email, password = _a.password, lastName = _a.lastName, firstName = _a.firstName, role = _a.role, normDays = _a.normDays, normHours = _a.normHours, travelTime = _a.travelTime, lunchTime = _a.lunchTime, isActive = _a.isActive, selectedCompanyIds = _a.selectedCompanyIds, canPreviewGpsProposal = _a.canPreviewGpsProposal;
        var user = _.cloneDeep(this.props.user);
        return __assign(__assign({}, user), { username: username, email: email, password: password, lastName: lastName, firstName: firstName, role: role, settings: __assign(__assign({}, user.settings), { normDays: normDays, normHours: normHours, lunchTime: lunchTime, travelTime: travelTime, companies: selectedCompanyIds, canPreviewGpsProposal: canPreviewGpsProposal }), isActive: !!+isActive });
    };
    UserDataForm.prototype.onFormSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var exists;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.props.user._id && this.props.checkEmailExists)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.checkEmailExists(this.state.email)];
                    case 1:
                        exists = _a.sent();
                        if (exists) {
                            this.setState({ emailError: 'Dit e-mailadres is al geregistreerd' });
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.setState({ emailError: '' });
                        this.props.updateUser(this.transformStateToUSer());
                        return [2 /*return*/];
                }
            });
        });
    };
    UserDataForm.prototype.handleCompanyChange = function (companyId, checked) {
        var newSelection = checked
            ? __spreadArray(__spreadArray([], this.state.selectedCompanyIds, true), [companyId], false) : this.state.selectedCompanyIds.filter(function (id) { return id !== companyId; });
        this.setState({ selectedCompanyIds: newSelection });
    };
    UserDataForm.prototype.handleUsernameChange = function (e) {
        var username = this.handleInputChange(e);
        this.setState({ email: "".concat(username, "@msq.secondcompany.nl") });
    };
    UserDataForm.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        var inputsDisabled = this.props.user.type === Identity_1.UserType.APP;
        return (React.createElement(index_1.Form, { error: this.props.error, onSubmit: function () { return _this.onFormSubmit(); } },
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "username", className: "required" }, "Gebruikersnaam "),
                React.createElement("input", { name: "username", type: "text", value: this.state.username, onChange: function (e) { return _this.handleUsernameChange(e); }, required: true, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "email", className: "required" }, "E-mail"),
                React.createElement("input", { name: "email", type: "email", value: this.state.email, onChange: function (e) {
                        _this.handleInputChange(e);
                        _this.setState({ emailError: '' });
                    }, required: true, disabled: inputsDisabled })),
            this.state.emailError && (React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                React.createElement("span", { className: "error-message" }, this.state.emailError))),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "password", className: this.props.user._id ? '' : 'required' }, "Wachwoord "),
                React.createElement("input", { name: "password", type: "password", value: this.state.password, onChange: function (e) { return _this.handleInputChange(e); }, required: !this.props.user._id })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "firstName" }, "Voornaam "),
                React.createElement("input", { name: "firstName", type: "text", value: this.state.firstName, onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "lastNamePrefix" }, "Tussenvoegsel "),
                React.createElement("input", { name: "lastNamePrefix", type: "text", value: this.state.lastNamePrefix || '', onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "lastName" }, "Achternaam "),
                React.createElement("input", { name: "lastName", type: "text", value: this.state.lastName, onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            inputsDisabled &&
                React.createElement(layout_1.Row, { justifyContent: "space-between" },
                    React.createElement("label", { htmlFor: "role" }, "Vakgroep "),
                    React.createElement("input", { name: "role", type: "text", value: ((_a = this.state.roles) === null || _a === void 0 ? void 0 : _a[this.state.role]) || '', disabled: true })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "normDays" }, "Norm dagen "),
                React.createElement("input", { name: "normDays", type: "text", value: this.state.normDays, onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "normHours" }, "Norm hours "),
                React.createElement("input", { name: "normHours", type: "text", value: this.state.normHours, onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "travelTime" }, "Eigen tijd "),
                React.createElement("input", { name: "travelTime", type: "text", value: this.state.travelTime, onChange: function (e) { return _this.handleInputChange(e); }, disabled: inputsDisabled })),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "lunchTime" }, "Lunchtijd "),
                React.createElement("input", { name: "lunchTime", type: "text", value: this.state.lunchTime, onChange: function (e) { return _this.handleInputChange(e); } })),
            !inputsDisabled &&
                React.createElement(layout_1.Row, { justifyContent: "space-between" },
                    React.createElement("label", { htmlFor: "role", className: "required" }, "Rol"),
                    React.createElement("select", { name: "role", value: this.state.role, required: true, onChange: function (e) { return _this.handleInputChange(e); }, disabled: this.state.role === model_1.UserRoles.ADMIN }, this.state.role === model_1.UserRoles.ADMIN ?
                        React.createElement("option", { value: model_1.UserRoles.ADMIN }, model_1.ADMIN_ROLES[Identity_1.UserType.PORTAL][model_1.UserRoles.ADMIN]) :
                        _.keys(this.state.roles).map(function (role) {
                            return React.createElement("option", { key: role, value: role }, _this.state.roles[role]);
                        }))),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "companies" }, "Bedrijven"),
                React.createElement("div", { className: "company-multi-select" }, Object.values(this.props.companies)
                    .filter(function (company) {
                    return _this.props.isSuperAdmin ||
                        (_this.props.currentUserCompanyIds && _this.props.currentUserCompanyIds.includes(company._id));
                })
                    .map(function (company) { return (React.createElement("label", { key: company._id, className: "company-checkbox" },
                    React.createElement("input", { type: "checkbox", checked: _this.state.selectedCompanyIds.includes(company._id), onChange: function (e) { return _this.handleCompanyChange(company._id, e.target.checked); } }),
                    company.name)); }))),
            this.props.canGrantGpsProposal && this.props.user.type === Identity_1.UserType.PORTAL &&
                React.createElement(layout_1.Row, { justifyContent: "space-between" },
                    React.createElement("label", { htmlFor: "canPreviewGpsProposal" }, "GPS-voorstel bekijken"),
                    React.createElement("select", { name: "canPreviewGpsProposal", value: this.state.canPreviewGpsProposal ? 1 : 0, onChange: function (e) {
                            return _this.setState({ canPreviewGpsProposal: !!Number(e.target.value) });
                        } },
                        React.createElement("option", { value: 1 }, " Ja "),
                        React.createElement("option", { value: 0 }, " Nee "))),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("label", { htmlFor: "isActive", className: "required" }, "In dienst"),
                React.createElement("select", { name: "isActive", value: this.state.isActive, required: true, onChange: function (e) { return _this.handleInputChange(e); } },
                    React.createElement("option", { value: 1 }, " Ja "),
                    React.createElement("option", { value: 0 }, " Nee "))),
            this.props.user.type === Identity_1.UserType.APP &&
                React.createElement(React.Fragment, null,
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null, UsersTable_1.H_LAST_LOGIN),
                        React.createElement("span", null, ((_c = (_b = this.props.user) === null || _b === void 0 ? void 0 : _b.deviceSettings) === null || _c === void 0 ? void 0 : _c.lastLogin) ?
                            moment(this.props.user.deviceSettings.lastLogin).format('YYYY-MM-DD HH:mm') : '')),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null, UsersTable_1.H_LAST_LOGOUT),
                        React.createElement("span", null, ((_e = (_d = this.props.user) === null || _d === void 0 ? void 0 : _d.deviceSettings) === null || _e === void 0 ? void 0 : _e.lastLogout) ?
                            moment(this.props.user.deviceSettings.lastLogout).format('YYYY-MM-DD HH:mm') : '')),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null,
                            UsersTable_1.H_LAST_ACTIVE,
                            "(",
                            'Breedtegraad',
                            ")"),
                        React.createElement("span", null, ((_g = (_f = this.props.user) === null || _f === void 0 ? void 0 : _f.lastLocation) === null || _g === void 0 ? void 0 : _g.latitude) ?
                            "".concat(parseFloat((_k = (_j = (_h = this.props) === null || _h === void 0 ? void 0 : _h.user) === null || _j === void 0 ? void 0 : _j.lastLocation) === null || _k === void 0 ? void 0 : _k.latitude.toFixed(2))) : '')),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null,
                            UsersTable_1.H_LAST_ACTIVE,
                            "(",
                            'Lengtegraad',
                            ")"),
                        React.createElement("span", null, ((_m = (_l = this.props.user) === null || _l === void 0 ? void 0 : _l.lastLocation) === null || _m === void 0 ? void 0 : _m.longitude) ?
                            "".concat(parseFloat((_q = (_p = (_o = this.props) === null || _o === void 0 ? void 0 : _o.user) === null || _p === void 0 ? void 0 : _p.lastLocation) === null || _q === void 0 ? void 0 : _q.longitude.toFixed(2))) : '')),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null,
                            UsersTable_1.H_LAST_ACTIVE,
                            "(",
                            'Bijgewerkt op',
                            ")"),
                        React.createElement("span", null, ((_s = (_r = this.props.user) === null || _r === void 0 ? void 0 : _r.lastLocation) === null || _s === void 0 ? void 0 : _s.updatedAt) ?
                            moment(this.props.user.lastLocation.updatedAt).format('YYYY-MM-DD HH:mm') : '')),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null, UsersTable_1.H_GEOLOCATION),
                        React.createElement("span", null, (0, UsersTable_1.userGPSInfo)(this.props.user))),
                    React.createElement(layout_1.Row, { justifyContent: "space-between" },
                        React.createElement("label", null, UsersTable_1.H_DEVICE_TYPE),
                        React.createElement("span", null, ((_u = (_t = this.props.user) === null || _t === void 0 ? void 0 : _t.deviceSettings) === null || _u === void 0 ? void 0 : _u.deviceType) ?
                            "".concat((_w = (_v = this.props.user) === null || _v === void 0 ? void 0 : _v.deviceSettings) === null || _w === void 0 ? void 0 : _w.deviceType, " ").concat(((_y = (_x = this.props.user) === null || _x === void 0 ? void 0 : _x.deviceSettings) === null || _y === void 0 ? void 0 : _y.osVersion) || '') : ''))),
            React.createElement(layout_1.Row, { justifyContent: "space-between" },
                React.createElement("input", { type: "submit", value: this.props.user._id || this.props.user.type === Identity_1.UserType.APP ? 'Bijwerken' : 'Toevoegen', className: "button" }))));
    };
    return UserDataForm;
}(FormComponent_1.default));
var mapStateToProps = function (store) {
    return {
        companies: store.reducer.manageUsersState.companies,
        error: store.reducer.api.updateUser.errorMessage,
    };
};
var mergeProps = function (stateProps, _dispatchProps, ownProps) {
    return __assign(__assign({}, stateProps), ownProps);
};
var Container = (0, react_redux_1.connect)(mapStateToProps, null, mergeProps)(UserDataForm);
exports.default = Container;
